module.exports = __webpack_public_path__ + "static/media/seat_arrangement_title.7b2fd6f0.jpg";